/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { Ref } from "react";
import { forwardRef } from "react";
import { Flex } from "../../utilities";
import type { ButtonGroupProps } from "./ButtonGroup.types";

const ButtonGroup = forwardRef(
  (
    {
      children,
      size = "medium",
      isInline = false,
      sx,
      className,
      direction = "horizontal",
      clearFix = false,
      ...restProps
    }: ButtonGroupProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <Flex
        ref={ref}
        className={className}
        display={isInline ? "inline-flex" : "flex"}
        width={isInline ? "auto" : "100%"}
        flexDirection={direction === "horizontal" ? "row" : "column"}
        justifyContent={clearFix ? "space-between" : "initial"}
        gap={vars.spacing[size === "small" ? "15" : 2]}
        sx={sx}
        {...restProps}
      >
        {children}
      </Flex>
    );
  },
);

ButtonGroup.displayName = "ButtonGroup";

const ButtonGroupInner = (props: Omit<ButtonGroupProps, "isInline" | "clearFix" | "direction">) => (
  <ButtonGroup isInline {...props} />
);

const ButtonGroupNamespace = Object.assign(ButtonGroup, {
  /**
   * ButtonGroup에 clearFix + 버튼이 3개인 케이스에 사용됩니다.
   *
   * size를 조정해, 간격을 조정할 수 있습니다.
   */
  Inner: ButtonGroupInner,
});

export { ButtonGroupNamespace as ButtonGroup };
